import React from 'react'
import { useOutletContext } from 'react-router-dom';
import Sidebar from '../../../../components/sidebar';
import PlanPricingTab from './PlanPricingTab/page';

const PlanList = () => {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();

  return (
    <>
      <div className="layout">
        {/* Sidebar */}
        <Sidebar isOpen={isSidebarOpen} />

        <div className='pricingPage'>
          {/* Page Content */}
          <div className="content">
            {/* Featured Plans */}
            <section className="featured-plan">
              <div className="container">
                <div className="section-heading">
                  <h1>Affordable Pricing</h1>
                  <p className="sub-title">
                    Get started with a 7 days free trial. <br /> Choose the plan that best fits your business needs.
                  </p>
                </div>
                <PlanPricingTab />
              </div>
            </section>
            {/* /Featured Plans */}
          </div>
          {/* /Page Content */}
        </div>

      </div>
    </>
  )
}

export default PlanList